import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import draftToHtml from 'draftjs-to-html';

const draftComponents = {
  h1: 'header-one',
  h2: 'header-two',
  h3: 'header-three',
  h4: 'header-four',
  h5: 'header-five',
  h6: 'header-six',
};

function TypographyDraft({
  className,
  classes,
  contrast,
  paragraph,
  component,
  sheet,
  theme,
  data,
  ...other
}) {
  const styledData = {
    ...data,
    blocks: [
      ...data.blocks.map(block => ({ ...block, type: draftComponents[component] || 'unstyled' })),
    ],
  };

  const computedClasses = classNames(
    classes.root,
    contrast && classes.contrast,
    paragraph && classes.paragraph,
    className,
  );

  const elements = ReactHtmlParser(draftToHtml(styledData));
  return (
    <div className={computedClasses} {...other}>
      {elements.map(element =>
        React.cloneElement(element, { className: component && classes[component] }),
      )}
    </div>
  );
}

TypographyDraft.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  component: PropTypes.string,
  contrast: PropTypes.bool,
  paragraph: PropTypes.bool,
  sheet: PropTypes.object,
  theme: PropTypes.object,
  data: PropTypes.object.isRequired,
};

TypographyDraft.defaultProps = {
  className: null,
  component: null,
  contrast: false,
  paragraph: false,
  sheet: null,
  theme: null,
};

const stylesheet = theme => ({
  root: {
    display: 'block',
    margin: 0,
    whiteSpace: 'pre-line',
    '& *': {
      margin: 0,
    },
  },
  h1: theme.typography.h1,
  h2: theme.typography.h2,
  h3: theme.typography.h3,
  h4: theme.typography.h4,
  h5: theme.typography.h5,
  h6: theme.typography.h6,
  constrast: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  paragraph: {
    marginBottom: 3 * theme.spacing.unit,
  },
});

export default injectSheet(stylesheet)(TypographyDraft);



// WEBPACK FOOTER //
// ./src/site-render/src/TypographyDraft/TypographyDraft.js